"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const native_1 = require("styled-components/native");
const BackIcon_1 = __importDefault(require("../Icons/BackIcon"));
const S = __importStar(require("./CustomHeader.styles"));
const CustomHeader = (props) => {
    const { onBack, headerText, height = '118px', borderWidth = 0, backgroundColor, color, center = false, } = props;
    const theme = native_1.useTheme();
    return (react_1.default.createElement(S.Header, { height: height, borderWidth: borderWidth, backgroundColor: backgroundColor || theme.header.background, center: center },
        react_1.default.createElement(S.ButtonIcon, { onPress: () => onBack(), center: center, testID: "ButtonIcon" },
            react_1.default.createElement(BackIcon_1.default, { color: color || theme.header.color, width: "20", height: "16" })),
        react_1.default.createElement(S.HeaderTextWrapper, null,
            react_1.default.createElement(S.HeaderText, { color: color || theme.header.color }, headerText))));
};
CustomHeader.defaultProps = {
    height: '118px',
    borderWidth: 0,
    center: false,
};
exports.default = CustomHeader;
